module.exports = __webpack_public_path__ + "img/relx-mechanics-img.093b2a89.png";